import { cn } from "@wags/ui/ui-utils";
import { TINTED_PANEL_CLASS } from "@/components/shared/tintedPanel";
import {
    compact as compactRows,
    goodWithValue,
    joinParts,
    type ListingData,
} from "./listing-section-data";

export function VitalsSection({
    data,
    compact = false,
}: {
    data: ListingData;
    compact?: boolean;
}) {
    const rows = compactRows([
        data.breedName && { label: "Breed", value: data.breedName },
        data.ageLabel && { label: "Age", value: data.ageLabel },
        data.sexLabel && { label: "Sex", value: data.sexLabel },
        data.sizeLabel && {
            label: "Size",
            value: data.weightRange
                ? `${data.sizeLabel} · ${data.weightRange}`
                : data.sizeLabel,
        },
        data.goodWith?.length && {
            label: "Good with",
            value: goodWithValue(data.goodWith),
        },
        {
            label: "From",
            value: joinParts([data.city, data.distanceLabel]),
        },
    ]).filter((row): row is { label: string; value: string } =>
        Boolean(row.value),
    );

    const content = (
        <>
            {!compact && <h2 className="sr-only">At a glance</h2>}
            <div className="flex flex-col">
                {rows.map((row, i) => (
                    <div
                        key={row.label}
                        className={
                            i === 0
                                ? `flex items-baseline justify-between gap-4 ${compact ? "pb-2.5" : "pb-3"}`
                                : `flex items-baseline justify-between gap-4 border-t border-doberman-black/10 ${compact ? "py-2.5" : "py-3"} last:pb-0`
                        }
                    >
                        <span className="text-body text-doberman-black/55">
                            {row.label}
                        </span>
                        <span className="text-right text-body font-semibold text-doberman-black">
                            {row.value}
                        </span>
                    </div>
                ))}
            </div>
        </>
    );

    return <div className={cn(TINTED_PANEL_CLASS, "text-left")}>{content}</div>;
}
